import type { EntryStatus } from '@innerloopco/loopcms-core'
import '../../styles/workspace.css'

const LABEL: Record<EntryStatus, string> = {
  published: 'Published',
  draft: 'Draft',
  in_review: 'In review',
  approved: 'Approved',
  scheduled: 'Scheduled',
}

/**
 * Nocturne 2's dot pill: every status shares one neutral pill and only the
 * dot carries the colour (see .lc-status-* in workspace.css), so a column of
 * statuses stays quiet while still scanning at a glance.
 */
export function StatusTag({ status }: { status: EntryStatus }) {
  return <span className={`tag tag-neutral tag-dot lc-status lc-status-${status}`}>{LABEL[status]}</span>
}
